import classes from './overlayWithSpinner.module.scss';

const OverlayWithSpinner = ({ isLoading = true }) => {
    return isLoading ? <div data-testid={'overlay-with-spinner'} className={classes.overlayWithSpinner} /> : null;
};

export default OverlayWithSpinner;
